<template>
  <div class="car-dialog _boxBg_small  absolute_center">
    <div class="_closeBox" @click="close"></div>
    <div class="_boxTitle" :class="{ dialog_title0: dialog.carType == '清洁车' }">
      <i></i>
      {{ dialog.carType }}
    </div>
    <div class="car-list" v-if="detailShow">
      <!--洗车机没有-->
      <div class="dialog_form" v-if="dialog.carType == '清洁车'">
        <div class="public-form">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="车辆类型：" prop="timeArr">
              <el-select v-model="type_value" placeholder="请选择">
                <el-option
                  v-for="item in type_options"
                  :key="item.typeId"
                  :label="item.typeName"
                  :value="item.typeId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="checkListFun">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table_box box" v-if="dialog.carType == '洗车机'">
        <el-table :data="tableData" @row-click="rowClick" style="width: 100%">
          <el-table-column label="序号" type="index" align="center" width="80">
          </el-table-column>
          <el-table-column align="center" prop="name" label="位置名称"> </el-table-column>
          <el-table-column align="center" prop="todaycount" label="今日洗车次数">
          </el-table-column>
          <el-table-column align="center" prop="yesterdaycount" label="昨日洗车次数">
          </el-table-column>
          <el-table-column align="center" prop="allcount" label="累计洗车次数">
          </el-table-column>
          <el-table-column align="center" prop="create_time" label="安装使用时间">
          </el-table-column>
        </el-table>
      </div>
      <div class="table_box box qing_table_box" v-else>
        <el-table :data="tableData" @row-click="rowClick" style="width: 100%">
          <el-table-column label="序号" type="index" align="center" width="80">
          </el-table-column>
          <el-table-column align="center" prop="deviceName" label="车牌号">
          </el-table-column>
          <el-table-column align="center" prop="typeName" label="车辆类型">
          </el-table-column>
          <el-table-column align="center" prop="todaycount" label="今日调度次数">
          </el-table-column>
          <el-table-column align="center" prop="distance" label="今日行驶里程">
          </el-table-column>
          <el-table-column align="center" prop="yesDistance" label="昨日行驶里程">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="car-detail" v-else>
      <div class="dialog_detail_title">
        <i @click="comeback"></i>
        <span v-if="dialog.carType == '洗车机'">{{ rowDetail.name }}</span>
        <span v-if="dialog.carType == '清洁车'"
          >{{ rowDetail.typeName }}-{{ rowDetail.deviceName }}</span
        >
      </div>
      <div style="margin-left: 10px">
        <div class="dialog_form">
          <div class="public-form">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="起止时间：" prop="timeArr">
<!--                <el-date-picker
                  v-model="timeArr"
                  type="datetimerange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                  &lt;!&ndash; value-format="yyyy-MM-dd HH:mm:ss" &ndash;&gt;
                </el-date-picker>-->
                <DatePicker
                  :init-width="'420px'"
                  :start-time-str="timeArr[0]"
                  :end-time-str="timeArr[1]"
                  :current-date-list="timeArr"
                  @dateChange="changeTime"
                  topPx="50px"
                  dateType="timerange"
                >
                </DatePicker>
              </el-form-item>
              <el-form-item>
                <el-button @click="checkFun">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="dialog_msg">
          <ul v-if="dialog.carType == '洗车机'">
            <li class="xi_li">
              <label>今日洗车次数：</label
              ><span class="msg_span">{{ detailXiData.todaycount }}</span>
            </li>
            <li class="xi_li">
              <label>昨日洗车次数：</label
              ><span class="msg_span">{{ detailXiData.yesterdaycount }}</span>
            </li>
            <li class="xi_li">
              <label>安装使用时间：</label
              ><span class="msg_span">{{ detailXiData.time }}</span>
            </li>
            <li class="xi_li">
              <label>烘干设施：</label
              ><span class="msg_span">{{
                detailXiData.is_drying_device == 1 ? "是" : "否"
              }}</span>
            </li>
            <li class="xi_li">
              <label>抖水装置：</label
              ><span class="msg_span">{{
                detailXiData.is_water_shaking_table == 1 ? "是" : "否"
              }}</span>
            </li>
            <li class="xi_li">
              <label>污水处理装置：</label
              ><span class="msg_span">{{
                detailXiData.is_sewage_treatment == 1 ? "是" : "否"
              }}</span>
            </li>
          </ul>
          <ul v-else>
            <li>
              <label>今日调度次数：</label
              ><span class="msg_span">{{ detailData[0].veBase.toCount }}</span
              >&nbsp;次
            </li>
            <li>
              <label>昨日调度次数：</label
              ><span class="msg_span">{{ detailData[0].veBase.yesCount }}</span
              >&nbsp;次
            </li>
            <li>
              <label>今日行驶里程：</label
              ><span class="msg_span">{{ detailData[0].veBase.toDistance }}</span
              >&nbsp;km
            </li>
            <li>
              <label>昨日行驶里程：</label
              ><span class="msg_span">{{ detailData[0].veBase.yesDistance }}</span
              >&nbsp;km
            </li>
          </ul>
        </div>
        <div class="car_title_two">工作记录</div>
        <div
          class="car_work_record"
          v-if="dialog.carType == '洗车机' && detailXiData.page.records.length"
        >
          <div class="table_box table_box_detail">
            <el-table :data="detailXiData.page.records" style="width: 100%">
              <template v-for="(item, index) in headArr">
                <el-table-column
                  v-if="item.show != false"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  :type="item.type ? item.type : ''"
                  :align="item.align ? item.align : 'center'"
                  :width="item.width ? item.width : 'initial'"
                >
                  <template #default="scope">
                    <span>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
          <div class="page_box">
            <el-pagination
              :pager-count="3"
              @current-change="handleCurrentChange"
              :current-page="paramsDetail.pageNo"
              :page-size="paramsDetail.pageSize"
              layout="total,prev, pager, next, jumper"
              :total="detailXiData.page.total"
            ></el-pagination>
            <p style="white-space: nowrap">跳转</p>
          </div>
        </div>
        <div
          class="car_work_record"
          v-else-if="dialog.carType == '清洁车' && detailData[0].veDetail.length"
        >
          <ul class="car_work_record_ul">
            <li
              class="car_work_record_li"
              v-for="(item, i) in detailData[0].veDetail"
              :key="i"
            >
              <div class="record_time">{{ item.creatTime }}</div>
              <div class="record_txt">{{ item.handleDetail }}</div>
            </li>
          </ul>
        </div>
        <div class="car_work_record noData" v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, getCurrentInstance } from "vue";
import { useStore, mapState, mapGetters, mapActions } from "vuex";
// import {parseTime} from "@/utils"
import { DatePicker } from "@/modules/commonDatePicker";
export default {
  name: "car-dialog",
  title: "车记录",
  props: ["dialog", "globalInstance"],
  setup(props) {
    const dialog = props.dialog;
    const globalInstance = props.globalInstance;
    return { dialog, globalInstance };
  },
  data() {
    return {
      customerId: this.globalInstance.$store.state.customerId,
      detailShow: true,
      carName: "",
      type_options: [], //车辆类型下拉
      type_value: "",
      //清洁车/洗车机
      paramsVehicleInfo: {
        customerId: this.globalInstance.$store.state.customerId,
        startTime: this.formatDateTime(new Date().getTime()) + " 00:00:00",
        endTime: this.formatDateTime(new Date().getTime()) + " 23:59:59",
        //				endTime: new Date(),
        typeId: "",
      },
      tableData: [],
      rowDetail: {},
      //清洁车/洗车机
      paramsDetail: {
        customerId: this.globalInstance.$store.state.customerId,
        dtuNum: "",
        pageNo: 1,
        pageSize: 50,
        startTime: this.formatDateTime(new Date().getTime()) + " 00:00:00",
        endTime: this.formatDateTime(new Date().getTime()) + " 23:59:59",
      },
      timeArr: [],
      detailTime: "",
      detailXiData: {}, //洗车机
      detailData: [{ veBase: {}, veDetail: [] }], //清洁车
      options: [
        {
          value: "",
          label: "",
        },
      ],
      value: "",
      headArr: [
        {
          label: "车牌号",
          prop: "car_name",
        },
        {
          label: "开始时间",
          prop: "startTime",
          width: "220px",
        },
        {
          label: "洗车时长",
          prop: "runTime",
        },
        {
          label: "结束时间",
          prop: "endTime",
          width: "220px",
        },
        {
          label: "平均水压",
          prop: "pressure",
        },
      ],
    };
  },
  watch: {
    "dialog.carType"(val) {
      this.carName = val;
      this.tableData = [];
      this.detailShow = true; //显示列表显示列表
      if (val == "洗车机") {
        this.carName = "洗车机";
      } else if (val == "清洁车") {
        //0
        this.carName = "清洁车";
      }
      this.getListData();
    },
  },
  mounted() {
    this.getCarType();
    this.getListData();
  },
  computed: {
  },
  components:{
    DatePicker
  },
  methods: {
    changeTime(e) {
      this.timeArr = e;
    },
    async getCarType() {
      let data = await this.globalInstance.$apiUtils.get(
        "/newscreen/control/getVehicleType",
        {
          customerId: this.customerId,
        }
      );
      this.type_options = data;
      this.type_options.unshift({ typeName: "全部车辆", typeId: "" });
    },
    async getListData() {
      let data = null;
      if (this.dialog.carType == "洗车机") {
        data = await this.globalInstance.$apiUtils.get(
          "/car_wash/getCarWashInfo",
          this.paramsVehicleInfo
        );
      } else if (this.dialog.carType == "清洁车") {
        data = await this.globalInstance.$apiUtils.get(
          "/newscreen/control/getVehicleInfo",
          this.paramsVehicleInfo
        );
      }
      this.tableData = data;
    },
    async getDetailData() {
      let data = null;
      if (this.dialog.carType == "洗车机") {
        data = await this.globalInstance.$apiUtils.get(
          "/car_wash/getCarWashProcessInfo",
          this.paramsDetail
        );
        this.detailXiData = data;
      } else if (this.dialog.carType == "清洁车") {
        data = await this.globalInstance.$apiUtils.get(
          "/newscreen/control/getVehicleDetail",
          this.paramsDetail
        );
        this.detailData = data;
      }
    },
    checkListFun() {
      this.paramsVehicleInfo.typeId = this.type_value;
      this.getListData();
    },
    rowClick(row) {
      this.rowDetail = row;
      this.paramsDetail.dtuNum = this.rowDetail.dtu_num
        ? this.rowDetail.dtu_num
        : this.rowDetail.dtuNum;
      this.getDetailData();
      this.detailShow = !this.detailShow;
    },
    comeback() {
      this.timeArr = [];
      this.detailXiData = {};
      this.detailData = [];
      this.detailShow = !this.detailShow;
    },
    checkFun() {
      if (this.timeArr.length) {
        this.paramsDetail.startTime = this.timeArr[0];
        this.paramsDetail.endTime = this.timeArr[1];
      } else {
        this.paramsDetail.startTime = "";
        this.paramsDetail.endTime = "";
      }
      this.getDetailData();
    },
    dropFun(val) {},
    handleCurrentChange(val) {
      this.paramsDetail.pageNo = val;
      this.getDetailData();
    },
    formatDateTime(inputTime) {
      inputTime = parseInt(inputTime);
      if (inputTime) {
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? "0" + minute : minute;
        second = second < 10 ? "0" + second : second;
        return y + "-" + m + "-" + d;
      }
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.car-dialog {
  width: 920px;
  height: 700px;
  padding: 30px 36px;

  .car-list {
    .dialog_title0 {
      background-image: url("../img/car/car_title2.png");
    }
    .dialog_form {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0 20px 0;
      .dialog_name {
        font-size: 28px;
        position: relative;
        margin-left: 20px;
        &:before {
          content: "";
          position: absolute;
          top: 50%;
          margin-top: -5px;
          left: -20px;
          width: 11px;
          height: 11px;
          background: rgba(71, 147, 176, 1);
          border-radius: 50%;
          opacity: 1;
        }
      }
      .dialog_check {
        width: 45%;
        display: flex;
        justify-content: flex-start;
        li {
          width: 155px;
          height: 35px;
          line-height: 35px;
          background-size: 100% 100%;
          text-align: center;
          background-image: url("../img/car/carInput.png");
          font-size: 17px;
          &:last-of-type {
            width: 113px;
            background-image: url("../img/dialogCheck.png");
            margin-left: 30px;
            cursor: pointer;
          }
          .el-date-editor.el-input,
          .el-date-editor.el-input__inner {
            width: 100%;
          }
          .el-input--suffix .el-input__inner {
            padding-right: 0 !important;
          }
        }
      }
    }
  }
  .car-detail {
    .dialog_detail_title {
      width: 500px;
      height: 57px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 26px;
      i {
        width: 40px;
        height: 40px;
        background-image: url("../img/car/car_comeback.png");
        margin-right: 20px;
        cursor: pointer;
      }
    }
    .dialog_title0 {
      background-image: url("../img/car/car_title2.png");
    }
    .dialog_form {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 12px 0;
      .dialog_name {
        font-size: 28px;
        position: relative;
        margin-left: 20px;
        &:before {
          content: "";
          position: absolute;
          top: 50%;
          margin-top: -5px;
          left: -20px;
          width: 11px;
          height: 11px;
          background: rgba(71, 147, 176, 1);
          border-radius: 50%;
          opacity: 1;
        }
      }
      .dialog_check {
        width: 45%;
        display: flex;
        justify-content: flex-start;
        li {
          width: 155px;
          height: 35px;
          line-height: 35px;
          background-size: 100% 100%;
          text-align: center;
          background-image: url("../img/car/carInput.png");
          font-size: 22px;
          &:last-of-type {
            width: 113px;
            background-image: url("../img/dialogCheck.png");
            margin-left: 30px;
          }
          .el-date-editor.el-input,
          .el-date-editor.el-input__inner {
            width: 100%;
          }
          .el-input--suffix .el-input__inner {
            padding-right: 0 !important;
          }
        }
      }
    }
    .dialog_msg {
      /*height: 92px;*/
      font-size: 24px;
      background-image: url("../img/car/carForm.png");
      background-size: 100% 100%;
      ul {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 10px 20px;
        li {
          width: 285px;
          margin-bottom: 20px;
          label {
          }
          .msg_span {
            color: rgba(1, 254, 254, 1);
          }
        }
        .xi_li {
          width: 200px;
          white-space: nowrap;
        }
        .xi_li:nth-of-type(3),
        .xi_li:nth-of-type(6) {
          width: 295px;
        }
      }
    }
    .car_title_two {
      width: 175px;
      line-height: 35px;
      background-image: url("../img/car/carTitleTwo.png");
      background-size: 100% 100%;
      padding-left: 20px;
      margin: 20px 0 20px;
      font-size: 22px;
    }
    .car_work_record {
      height: 305px;
      padding-left: 5px;
      overflow: auto;
      .car_work_record_ul {
        border-left: 1px solid rgba(71, 109, 130, 1);
        padding-left: 30px;
        margin-left: 10px;
        .car_work_record_li {
          position: relative;
          margin-bottom: 20px;
          &:before {
            content: "";
            position: absolute;
            top: -5px;
            left: -47px;
            width: 33px;
            height: 33px;
            background: url("../img/car/carIcon.png");
          }
          .record_time {
            font-size: 20px;
            color: rgba(180, 189, 195, 1);
            margin-bottom: 10px;
          }
          .record_txt {
            font-size: 22px;
          }
        }
      }
    }
  }
}

.chart {
  width: 100%;
  height: 355px;
}
.table_box {
  .el-table {
    thead {
      font-size: 20px;
    }
    font-size: 20px;
  }
}
</style>
<style type="text/css">
.car-dialog .el-input--suffix .el-input__inner {
  padding-right: 0 !important;
  line-height: 41px !important;
}
.car-dialog .el-select-dropdown,
.el-popper {
  border: 0;
}
.car-dialog .el-scrollbar__wrap,
.el-select-dropdown__item {
  background: rgba(16, 50, 72, 0.97);
}
.car-dialog .el-select-dropdown__item.hover,
.car-dialog .el-select-dropdown__item:hover {
  background: rgba(45, 86, 128, 1) !important;
}
.car-dialog .el-icon-arrow-up:before,
.car-dialog .el-icon-arrow-up:after {
  display: none;
}
.car-dialog .el-select .el-input__inner,
.car-dialog .el-input .el-input__inner {
  color: #fff !important;
  font-size: 20px;
}

/*table*/
.car-dialog .is-leaf {
  background-color: #003f88;
}
.car-dialog .el-table__row:nth-of-type(even) {
  background: rgba(0, 63, 136, 0.5);
}
.car-dialog .el-table__row:nth-of-type(odd) {
  background: transparent;
}

.car-dialog .table_box .el-table__body-wrapper {
  height: 555px;
  overflow-y: auto !important;
}
.car-dialog .table_box_detail .el-table__body-wrapper {
  height: 166px;
  overflow-y: auto !important;
}
.car-dialog .qing_table_box .el-table__body-wrapper {
  height: 480px;
}
.car-dialog .el-table__row {
  cursor: pointer;
}
.car-dialog .public-form .el-form-item {
  margin: 0 0;
}
.car-dialog .el-range-editor.el-input__inner {
  width: 450px !important;
}
</style>
